export default __webpack_public_path__ + "static/media/right_arrow.9c73714d.svg";